import React from 'react';
import Card, { CardBody } from '../Card';
import ProgressBar from '../ProgressBar';

export default ({ complete, total }) => {
  const progress = Math.floor((complete / total) * 100);

  return (
    <Card>
      <CardBody className="d-flex flex-row align-items-center">
        <strong className="mr-2">{Lang.get('messages.dashboard.gameProgress')}</strong>
        <ProgressBar value={progress} label={`${progress}%`} />
      </CardBody>
    </Card>
  );
};
